import { IHoliday } from 'app/models/holiday';
import { IGetHolidaysByDateResponse } from 'app/models/responses/holiday';
import { serverAxios } from 'app/utils/axios';
import { AxiosResponse } from 'axios';

class HolidayHttp {
  private static route = '/';

  public async getByDates(dateFrom: string, dateTo: string): Promise<IHoliday[]> {
    return serverAxios
      .post(HolidayHttp.route, {
        act: 'holidaysfind',
        date1: dateFrom,
        date2: dateTo,
      })
      .then((response: AxiosResponse<IGetHolidaysByDateResponse>) => {
        return response.data.data;
      });
  }
}

export default HolidayHttp;
